<template>
  <div class="between-header bg-main">
    <swiper :options="swiperOption" ref="mySwiper" style="height: auto">
      <swiper-slide v-for="(item, index) in BannerTop" :key="index">
        <figure class="imgslide-full">
          <img :src="item.thumb" />
        </figure>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>

    <container>
      <div class="marquee-box">
        <div class="marquee-area">
          <div class="marquee">
            <span>{{ marquee }}</span>
            <span>{{ marquee }}</span>
          </div>
        </div>
        <div class="marquee-btn">
          <router-link to="/schedule">
            <btn class="btn btn-schedule"><i class="fa fa-table"></i> <span
                class="clearfix d-none d-sm-inline-block">ผังรายการ</span></btn>
          </router-link>
        </div>
      </div>
      <!--div class="">
      <p class="microsoft marquee">{{marquee}}</p>
      <div class="marquee-btn">
        <router-link to="/schedule"><btn class="btn btn-schedule"><i class="fa fa-table"></i> <span class="clearfix d-none d-sm-inline-block">ผังรายการ</span></btn></router-link>
      </div>
    </div-->

      <!--div class="">
      <router-link to="/schedule"><btn class="btn btn-schedule"><i class="fa fa-table"></i> <span class="clearfix d-none d-sm-inline-block">ผังรายการ</span></btn></router-link>
      <marquee-text>
      <p class="marquee-text">{{marquee}}</p>
      <p class="marquee-text">{{marquee}}</p>
    </marquee-text>
  </div-->


      <div class="content-video" v-if="rtaf.length && checkUser == 'true' || checkUser && checkUser === undefined">
        <div class="header-category">
          <h3 class="header-content"><i class="fa fa-fighter-jet"></i> RTAF NEWS</h3>
          <a class="btn-viewmore" href="/#/viewmore/rtaf" @click="Viewmore('rtaf')"><span
              class="clearfix d-none d-sm-inline-block">view more</span> <i class="fa fa-chevron-right"></i></a>
        </div>
        <slick ref="slick" :options="slickRTAFNEWS">
          <div class="video" v-for="video in rtaf" :key="video.id">
            <router-link :to="'/live/' + video.id">
              <div class="" @click="PlayLiveEvent(video)">
                <div class="preview-video">
                  <figure class="sixteen-nine-img">
                    <img :src="video.thumb" />
                    <div class="btn-overlay">
                      <fa icon="play" class="icon-play" />
                    </div>
                  </figure>
                  <div class="" v-if="video.live == 'true'">
                    <img src="../assets/img/live.png" class="icon-live">
                  </div>
                </div>
                <div class="card-content">
                  <p class="card-title">{{ video.name }}</p>
                  <!--p class="card-date">กำลังรับชม {{ video.views }} ท่าน</p-->
                  <p class="card-desc">{{ video.desc }}</p>
                </div>
              </div>
            </router-link>

            <!--div class="function" v-if="auth == 'true' && auth !== null">
            <btn class="btn-fav" type="submit" name="button"><fa icon="heart" class="icon-fav" /></btn>
            <btn class="btn-history" type="submit" name="button"><fa icon="history" class="icon-history" /></btn>
            <btn class="btn-share" type="submit" name="button" @click.native="modalShare = true" @click="ShareLink(video)"><fa icon="share" class="icon-share" /></btn>
          </div-->
          </div>
        </slick>
      </div>

      <div class="content-video" v-if="events.length && checkUser == 'true' || checkUser && checkUser === undefined">
        <div class="header-category">
          <h3 class="header-content"><i class="fa fa-fighter-jet"></i> Live Events</h3>
          <a href="/#/viewmore/liveevent" class="btn-viewmore" @click="Viewmore('liveevent')"><span
              class="clearfix d-none d-sm-inline-block">view more</span> <i class="fa fa-chevron-right"></i></a>
        </div>
        <slick ref="slick" :options="slickOptions">
          <div class="video" v-for="video in events" :key="video.id">
            <router-link :to="'/live/' + video.id">
              <div class="" @click="PlayLiveEvent(video)">
                <div class="preview-video">
                  <figure class="sixteen-nine-img">
                    <img :src="video.thumb" />
                    <div class="btn-overlay">
                      <fa icon="play" class="icon-play" />
                    </div>
                  </figure>
                  <div class="" v-if="video.live == 'true'">
                    <img src="../assets/img/live.png" class="icon-live">
                  </div>
                </div>
                <div class="card-content">
                  <p class="card-title">{{ video.name }}</p>
                  <!--p class="card-date">กำลังรับชม {{ video.views }} ท่าน</p-->
                  <p class="card-desc">{{ video.desc }}</p>
                </div>
              </div>
            </router-link>


            <!--div class="function" v-if="auth == 'true' && auth !== null">
            <btn class="btn-fav" type="submit" name="button"><fa icon="heart" class="icon-fav" /></btn>
            <btn class="btn-history" type="submit" name="button"><fa icon="history" class="icon-history" /></btn>
            <btn class="btn-share" type="submit" name="button" @click.native="modalShare = true" @click="ShareLink(video)"><fa icon="share" class="icon-share" /></btn>
          </div-->
          </div>
        </slick>
      </div>

      <div class="content-video" v-if="publicch.length">
        <div class="header-category">
          <h3 class="header-content"><i class="fa fa-fighter-jet"></i> Public Channel</h3>
          <a class="btn-viewmore" href="/#/viewmore/public" @click="Viewmore('public')"><span
              class="clearfix d-none d-sm-inline-block">view more</span> <i class="fa fa-chevron-right"></i></a>
        </div>
        <slick ref="slick" :options="slickOptions">
          <div class="video" v-for="video in publicch" :key="video.id">
            <router-link :to="'/public/' + video.id">
              <div class="" @click="PlayPublicChannel(video)">
                <div class="preview-video">
                  <figure class="sixteen-nine-img">
                    <img :src="video.thumb" />
                    <div class="btn-overlay">
                      <fa icon="play" class="icon-play" />
                    </div>
                  </figure>
                  <div class="" v-if="video.live == 'true'">
                    <img src="../assets/img/live.png" class="icon-live">
                  </div>
                </div>
                <div class="card-content">
                  <p class="card-title">{{ video.name }}</p>
                  <!--p class="card-date">กำลังรับชม {{ video.views }} ท่าน</p-->
                  <p class="card-desc">{{ video.desc }}</p>
                </div>
              </div>
            </router-link>
          </div>
        </slick>
      </div>

      <div class="content-video" v-if="educationch.length && checkUser == 'true' || checkUser && checkUser === undefined">
        <div class="header-category">
          <h3 class="header-content"><i class="fa fa-fighter-jet"></i> Education Channel</h3>
          <a class="btn-viewmore" href="/#/viewmore/education" @click="Viewmore('education')"><span
              class="clearfix d-none d-sm-inline-block">view more</span> <i class="fa fa-chevron-right"></i></a>
        </div>
        <slick ref="slick" :options="slickOptions">
          <div class="video" v-for="video in educationch" :key="video.id">
            <router-link :to="'/live/' + video.id">
              <div class="" @click="PlayLiveEvent(video)">
                <div class="preview-video">
                  <figure class="sixteen-nine-img">
                    <img :src="video.thumb" />
                    <div class="btn-overlay">
                      <fa icon="play" class="icon-play" />
                    </div>
                  </figure>
                  <div class="" v-if="video.live == 'true'">
                    <img src="../assets/img/live.png" class="icon-live">
                  </div>
                </div>
                <div class="card-content">
                  <p class="card-title">{{ video.name }}</p>
                  <!--p class="card-date">กำลังรับชม {{ video.views }} ท่าน</p-->
                  <p class="card-desc">{{ video.desc }}</p>
                </div>
              </div>
            </router-link>
          </div>
        </slick>
      </div>

      <div class="content-video" v-if="recommended.length && checkUser == 'true' || checkUser && checkUser === undefined">
        <div class="header-category">
          <h3 class="header-content"><i class="fa fa-fighter-jet"></i> Recommended</h3>
          <a class="btn-viewmore" href="/#/viewmore/recommended" @click="Viewmore('recommended')"><span
              class="clearfix d-none d-sm-inline-block">view more</span> <i class="fa fa-chevron-right"></i></a>
        </div>
        <div class="bigcontent" @click="PlayLastUpdate(recommended0)">
          <section class="cards-bigcontent">
            <div class="card-bigcontent">
              <div class="">
                <div class="preview-video">
                  <figure class="sixteen-nine-img">
                    <img :src="recommended0.thumb" />
                    <p class="duration">{{ recommended0.duration }}</p>
                    <div class="btn-overlay">
                      <fa icon="play" class="icon-play" />
                    </div>
                  </figure>
                </div>
                <div class="card-content">
                  <p class="card-title">{{ recommended0.name }}</p>
                  <p class="card-date">ดูทั้งหมด {{ Number(recommended0.views).toLocaleString() }} ครั้ง</p>
                  <p class="card-desc">{{ recommended0.desc }}</p>
                </div>
              </div>
            </div>
          </section>
        </div>


        <slick ref="slick" class="slick-recommended1" :options="slickOptions">
          <div class="video" v-for="video in recommended" :key="video.id">
            <router-link :to="'/vod/' + video.id">
              <div class="" @click="PlayLastUpdate(video)">
                <div class="preview-video">
                  <figure class="sixteen-nine-img">
                    <img :src="video.thumb" />
                    <p class="duration">{{ video.duration }}</p>
                    <div class="btn-overlay">
                      <fa icon="play" class="icon-play" />
                    </div>
                  </figure>
                  <div class="" v-if="video.live == 'true'">
                    <img src="../assets/img/live.png" class="icon-live">
                  </div>
                </div>
                <div class="card-content">
                  <p class="card-title">{{ video.name }}</p>
                  <p class="card-date">ดูทั้งหมด {{ Number(video.views).toLocaleString() }} ครั้ง</p>
                  <p class="card-desc">{{ video.desc }}</p>
                </div>
              </div>
            </router-link>

          </div>
        </slick>

        <slick ref="slick" class="slick-recommended2" :options="slickOptions">
          <div class="video" v-for="video in recommendedSlice" :key="video.id">
            <router-link :to="'/vod/' + video.id">
              <div class="" @click="PlayLastUpdate(video)">
                <div class="preview-video">
                  <figure class="sixteen-nine-img">
                    <img :src="video.thumb" />
                    <p class="duration">{{ video.duration }}</p>
                    <div class="btn-overlay">
                      <fa icon="play" class="icon-play" />
                    </div>
                  </figure>
                  <div class="" v-if="video.live == 'true'">
                    <img src="../assets/img/live.png" class="icon-live">
                  </div>
                </div>
                <div class="card-content">
                  <p class="card-title">{{ video.name }}</p>
                  <p class="card-date">ดูทั้งหมด {{ Number(video.views).toLocaleString() }} ครั้ง</p>
                  <p class="card-desc">{{ video.desc }}</p>
                </div>
              </div>
            </router-link>

          </div>
        </slick>
      </div>

      <div class="content-video" v-if="checkUser !== 'true'">
        <div class="content-cate" v-for="item in Category" v-if="item.videos.length !== 0 && item.public == 'enable'">
          <div class="header-category">
            <h3 class="header-content"><i class="fa fa-fighter-jet"></i> {{ item.name }}</h3>
            <router-link :to="'/viewmore/vodpublic/' + item.id">
              <a class="btn-viewmore" @click="ViewmoreCategory(item.id)"><span
                  class="clearfix d-none d-sm-inline-block">view more</span> <i class="fa fa-chevron-right"></i></a>
            </router-link>
          </div>
          <slick ref="slick" :options="slickOptions">
            <div class="video" v-for="video in item.videos.slice(0, 14)">
              <router-link :to="'/vodpublic/' + video._id">
                <div class="" @click="PlayVideoCategory(video._id)">
                  <div class="preview-video">
                    <figure class="sixteen-nine-img">
                      <img v-if="ThumborUse == false" :src="Thumb + '/' + video.thumb" />
                      <img v-if="ThumborUse == true"
                        :src="Thumbor + '/unsafe/365x213/' + encodeURIComponent(Thumb + '/' + video.thumb)" />
                      <p class="duration">{{ video.duration }}</p>
                      <div class="btn-overlay">
                        <fa icon="play" class="icon-play" />
                      </div>
                    </figure>
                  </div>
                  <div class="card-content">
                    <p class="card-title">{{ video.name }}</p>
                    <p class="card-date">ดูทั้งหมด {{ Number(video.views).toLocaleString() }} ครั้ง</p>
                    <p class="card-desc">{{ video.desc }}</p>
                  </div>
                </div>
              </router-link>
              <!--div class="function" v-if="auth == 'true' && auth !== null">
              <btn class="btn-fav" type="submit" name="button" @click="FunctionFavorite(video)">
                <fa icon="heart" class="" v-bind:class="[FavoriteActive(video.favorite) ? 'icon-fav' : 'icon-fav2']"/>
              </btn>
              <btn class="btn-history" type="submit" name="button" @click="AddWatchLater(video)"><fa icon="history" class="icon-history" /></btn>
              <btn class="btn-share" type="submit" name="button" @click.native="modalShare = true" @click="ShareLink(video)"><fa icon="share" class="icon-share"/></btn>
            </div-->
            </div>
          </slick>
        </div>
      </div>

      <div class="content-video" v-if="checkUser == 'true' || checkUser && checkUser === undefined">
        <div class="content-cate" v-for="item in Category" v-if="item.videos.length !== 0">
          <div class="header-category">
            <h3 class="header-content"><i class="fa fa-fighter-jet"></i> {{ item.name }}</h3>
            <router-link :to="'/viewmore/' + item.id">
              <a class="btn-viewmore" @click="ViewmoreCategory(item.id)"><span
                  class="clearfix d-none d-sm-inline-block">view more</span> <i class="fa fa-chevron-right"></i></a>
            </router-link>
          </div>
          <slick ref="slick" :options="slickOptions">
            <div class="video" v-for="video in item.videos.slice(0, 14)">
              <router-link :to="'/vod/' + video._id">
                <div class="" @click="PlayVideoCategory(video._id)">
                  <div class="preview-video">
                    <figure class="sixteen-nine-img">
                      <img v-if="ThumborUse == false" :src="Thumb + '/' + video.thumb" />
                      <img v-if="ThumborUse == true"
                        :src="Thumbor + '/unsafe/365x213/' + encodeURIComponent(Thumb + '/' + video.thumb)" />
                      <p class="duration">{{ video.duration }}</p>
                      <div class="btn-overlay">
                        <fa icon="play" class="icon-play" />
                      </div>
                    </figure>
                  </div>
                  <div class="card-content">
                    <p class="card-title">{{ video.name }}</p>
                    <p class="card-date">ดูทั้งหมด {{ Number(video.views).toLocaleString() }} ครั้ง</p>
                    <p class="card-desc">{{ video.desc }}</p>
                  </div>
                </div>
              </router-link>
              <!--div class="function" v-if="auth == 'true' && auth !== null">
              <btn class="btn-fav" type="submit" name="button" @click="FunctionFavorite(video)">
                <fa icon="heart" class="" v-bind:class="[FavoriteActive(video.favorite) ? 'icon-fav' : 'icon-fav2']"/>
              </btn>
              <btn class="btn-history" type="submit" name="button" @click="AddWatchLater(video)"><fa icon="history" class="icon-history" /></btn>
              <btn class="btn-share" type="submit" name="button" @click.native="modalShare = true" @click="ShareLink(video)"><fa icon="share" class="icon-share"/></btn>
            </div-->
            </div>
          </slick>
        </div>
      </div>

      <div class="content-video" v-if="lives.length && checkUser == 'true' || checkUser && checkUser === undefined">
        <div class="header-category">
          <h3 class="header-content"><i class="fa fa-fighter-jet"></i> Live Streaming Wing</h3>
          <a class="btn-viewmore" href="/#/viewmore/livestream" @click="Viewmore('livestream')"><span
              class="clearfix d-none d-sm-inline-block">view more</span> <i class="fa fa-chevron-right"></i></a>
        </div>
        <div class="bigcontent" @click="PlayLiveStreaming(live0)">
          <section class="cards-bigcontent">
            <div class="card-bigcontent">

              <div class="preview-video">
                <div class="" v-if="live0.live == 'true'">
                  <img src="../assets/img/live.png" class="icon-live-big">
                </div>
                <figure class="sixteen-nine-img">
                  <img :src="live0.thumb" />
                  <div class="btn-overlay">
                    <fa icon="play" class="icon-play" />
                  </div>
                </figure>
              </div>
              <div class="card-content">
                <p class="card-title">{{ live0.name }}</p>
                <!--p class="card-date">กำลังรับชม {{live0.views}} ท่าน</p-->
                <p class="card-desc">{{ live0.desc }}</p>
              </div>

            </div>
          </section>
        </div>

        <slick ref="slick" class="slick-livestream1" :options="slickOptions">
          <div class="video" v-for="video in lives" :key="video.id">
            <router-link :to="'/live/' + video.id">
              <div class="" @click="PlayLiveStreaming(video)">
                <div class="preview-video">
                  <figure class="sixteen-nine-img">
                    <img :src="video.thumb" />
                    <div class="btn-overlay">
                      <fa icon="play" class="icon-play" />
                    </div>
                  </figure>
                  <div class="" v-if="video.live == 'true'">
                    <img src="../assets/img/live.png" class="icon-live">
                  </div>
                </div>
                <div class="card-content">
                  <p class="card-title">{{ video.name }}</p>
                  <!--p class="card-date">กำลังรับชม {{ video.views }} ท่าน</p-->
                  <p class="card-desc">{{ video.desc }}</p>
                </div>
              </div>
            </router-link>

          </div>
        </slick>


        <slick ref="slick" class="slick-livestream2" :options="slickOptions">
          <div class="video" v-for="video in liveSlice" :key="video.id">
            <router-link :to="'/live/' + video.id">
              <div class="" @click="PlayLiveStreaming(video)">
                <div class="preview-video">
                  <figure class="sixteen-nine-img">
                    <img :src="video.thumb" />
                    <div class="btn-overlay">
                      <fa icon="play" class="icon-play" />
                    </div>
                  </figure>
                  <div class="" v-if="video.live == 'true'">
                    <img src="../assets/img/live.png" class="icon-live">
                  </div>
                </div>
                <div class="card-content">
                  <p class="card-title">{{ video.name }}</p>
                  <!--p class="card-date">กำลังรับชม {{ video.views }} ท่าน</p-->
                  <p class="card-desc">{{ video.desc }}</p>
                </div>
              </div>
            </router-link>

          </div>
        </slick>

      </div>

      <!-- Radio Channel -->
      <div class="content-video" v-if="radioCh.length && checkUser == 'true' || checkUser && checkUser === undefined">
        <div class="header-category">
          <h3 class="header-content"><i class="fa fa-fighter-jet"></i> วิทยุออนไลน์</h3>
          <!-- <a class="btn-viewmore" href="/#/viewmore/public" @click="Viewmore('public')"><span
              class="clearfix d-none d-sm-inline-block">view more</span> <i class="fa fa-chevron-right"></i></a> -->
        </div>
        <slick ref="slick" :options="slickOptions">
          <div class="radio" v-for="radio in radioCh" :key="radio.id">
            <!-- <router-link :to="'/public/' + radio.id" > -->
            <a>
              <div class="" @click="PlayRadioChannel(radio)">
                <div class="preview-radio">
                  <figure class="sixteen-nine-img">
                    <img :src="radio.thumb" />
                    <div class="btn-overlay">
                      <fa icon="play" class="icon-play" />
                    </div>
                  </figure>
                  <!-- <div class="" v-if="radio.live == 'true'">
                  <img src="../assets/img/live.png" class="icon-live">
                </div> -->
                </div>
                <div class="card-content">
                  <p class="card-title">{{ radio.name }}</p>
                  <p class="card-desc">{{ radio.desc }}</p>
                </div>
              </div>
            </a>
            <!-- </router-link> -->
          </div>
        </slick>
      </div>

      <div class="news">
        <h2 class="text-center header-news">News Feed</h2>
        <section class="cards">
          <div class="card-news" v-for="news in newsfeed" @click="ReadNews(news.url)">
            <figure class="sixteen-nine-img-news">
              <img :src="news.thumb" />
            </figure>
            <div class="card-content-news">
              <h4 class="card-title-news">{{ news.name }}</h4>
              <p class="card-desc-news">{{ news.desc }}</p>
            </div>
          </div>
        </section>

        <div class="text-center btn-allnews">
          <router-link to="/newsfeed">
            <btn class="btn btn-news blue-gradient btn-rounded">ดูข่าวทั้งหมด</btn>
          </router-link>
        </div>
      </div>

      <!-- Modal login -->
      <modal centered v-if="modalLogin" @close="modalLogin = false" ref="modalApp">
        <fa class="close-modal" color="white" icon="close" @click.native="modalLogin = false" />
        <modal-body class="body-login">
          <div class="text-center">
            <img src="../../src/assets/img/finallogo.png" class="img-logo-login">
            <h3 class="header-login">กองทัพอากาศ</h3>
          </div>
          <p class="alert-text">{{ Alertlogin }}{{ AlertForget }}</p>
          <div class="input-login">
            <div class="form-group">
              <input type="text" v-model="inputEmail" id="email" class="form-control form-control-md input-edit"
                placeholder="อีเมล">
            </div>
            <div class="form-group">
              <input :type="type" v-on:keyup.enter="Login()" v-model="inputPassword" id="password"
                class="form-control form-control-md input-edit" placeholder="รหัสผ่าน">
              <i class="fa fa-eye btn-show-pass" @click="ShowPassword()"
                :class="[btnShowpass ? 'fa fa-eye' : 'fa fa-eye-slash']"></i>
            </div>
            <div class="custom-control custom-checkbox">
              <input @click="RememberMe()" type="checkbox" class="custom-control-input" id="defaultChecked2"
                v-model="inputRemember">
              <label class="custom-control-label" for="defaultChecked2">จดจำฉัน</label>
            </div>
            <p class="forget-pass" @click="ClickForgetPass()"><a>ลืมรหัสผ่าน</a></p>

          </div>
          <div class="login-btn text-center">
            <btn class="btn-confirm-login btn-rounded btn-block" @click="Login()">เข้าสู่ระบบ</btn>
          </div>

        </modal-body>
      </modal>
      <!-- /Modal login -->

      <!-- Modal share -->
      <modal centered v-if="modalShare" @close="modalShare = false">
        <!--fa class="close-modal" color="danger" icon="close"@click.native="modalShare = false" /-->
        <modal-header>
          <modal-title>แชร์ลิ้งค์</modal-title>
        </modal-header>
        <modal-body>
          <div class="padding-share">
            <!--div class="text-center input-share">
          <input type="text" class="form-control shareLink" name="" value="" v-model="Link" disabled>
        </div-->
            <div class="input-link input-share">
              <input type="text" v-model="Link" id="linkURL" class="form-control shareLink" readonly="readonly">
              <btn color="primary" class="btn-chat" @click="CopyLink()"><span>คัดลอก</span></btn>
            </div>
            <!--div class="">
          <btn class="btn-email" color="white"><fa icon="envelope" class="icon-link" /> อีเมล</btn>
        </div>
        <div class="">
          <btn class="btn-facebook" color="primary"><fa icon="facebook" class="icon-social" /> facebook</btn>
        </div>
        <div class="">
          <btn class="btn-line" color=" green accent-4"><fa icon="line" class="icon-social" />Line</btn>
        </div-->
          </div>

        </modal-body>
      </modal>
      <!-- /Modal share -->

      <!-- Modal information -->
      <modal centered v-if="modalInformation" @close="closeModalInformation()" ref="modalApp">
        <fa class="close-modal" color="white" icon="close" @click.native="closeModalInformation()" />
        <modal-body class="body-information">
          <p class="text-information">สามารถรับชมวีดิโอต่างๆ และข่าวสารภายในได้มากขึ้น </br>เพียง Login ด้วย E-mail ของทอ.
          </p>
        </modal-body>
      </modal>

      <div id="floating-bar" class="floating-bar text-center">
        <!-- <button class="btn-close-radio" @click="toggleBarRadio">ปิด</button> -->
        <button class="btn-close-radio" @click="toggleBarRadio(false)"><i class="fa fa-times" aria-hidden="true"
            style="color: white;"></i></button>

        <!-- J Player -->
        <!-- <div id="jquery_jplayer_1"></div>
        <div id="jp_container_1">
          <a href="#" class="jp-play">Play</a>
          <a href="#" class="jp-pause">Pause</a>
        </div> -->

        <!-- START OF THE RADIO HTML5 PLAYER EMBEDDING -->
        <audio id="myAudio" controls="true" preload="none" style="height: 40px;">
          <source id="audio-src" src="http://radio12.plathong.net/7172/;stream.mp3/;stream.mp3" type="audio/mp3">
          Your browser does not support the audio element.
        </audio>
        <!-- END OF THE RADIO HTML5 PLAYER EMBEDDING -->

      </div>

    </container>
  </div>
</template>

<script>
import config from '../config';
import axios from 'axios';
const Host = config.app.Host;
const Thumb = config.app.Thumb;
const Thumbor = config.app.Thumbor;
const ThumborUse = config.app.ThumborUse;
import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
// import $ from 'jquery';
// import jPlayer from 'jplayer';
//import carousel from 'v-owl-carousel';
//import { Carousel, Slide } from 'vue-carousel';
import {
  Container,
  Column,
  Row,
  Fa,
  Navbar,
  NavbarItem,
  NavbarNav,
  NavbarCollapse,
  Btn,
  mdbBtn,
  EdgeHeader,
  CardBody,
  mdbCarousel,
  mdbCarouselItem,
  mdbDropdown,
  mdbDropdownToggle,
  mdbDropdownMenu,
  mdbDropdownItem,
  mdbIcon,
  mdbBadge,
  mdbCard,
  mdbCardImage,
  mdbCardHeader,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbCardFooter,
  mdbCardUp,
  mdbCardAvatar,
  mdbCardGroup,
  mdbView,
  mdbMask,
  Modal,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter
} from 'mdbvue';
export default {
  name: 'MainPage',
  components: {
    Container,
    Column,
    Row,
    Fa,
    Navbar,
    NavbarItem,
    NavbarNav,
    NavbarCollapse,
    Btn,
    mdbBtn,
    EdgeHeader,
    CardBody,
    mdbCarousel,
    mdbCarouselItem,
    mdbDropdown,
    mdbDropdownToggle,
    mdbDropdownMenu,
    mdbDropdownItem,
    mdbIcon,
    mdbBadge,
    mdbCard,
    mdbCardImage,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbCardFooter,
    mdbCardUp,
    mdbCardAvatar,
    mdbCardGroup,
    mdbView,
    mdbMask,
    Modal,
    ModalHeader,
    ModalTitle,
    ModalBody,
    ModalFooter,
    Slick,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      Thumbor: '',
      ThumborUse: false,
      modalInformation: false,
      linkMarquee: '',
      marquee: '',
      swiperOption: {
        infinite: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      slickBanner: {
        infinite: false,
        dots: true,
        speed: 500,
        fade: true,
        cssEase: 'linear'
      },
      slickRTAFNEWS: {
        infinite: false,
        prevArrow: "<a class='btn-floating slick-left'><i class='fa fa-chevron-left'></i></a>",
        nextArrow: "<a class='btn-floating slick-right'><i class='fa fa-chevron-right'></i></a>",
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [{
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            autoplay: false
          }
        },
        {
          breakpoint: 430,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: false,
            autoplay: false
          }
        }]
        // Any other options that can be got from plugin documentation
      },
      slickOptions: {
        infinite: false,
        prevArrow: "<a class='btn-floating slick-left'><i class='fa fa-chevron-left'></i></a>",
        nextArrow: "<a class='btn-floating slick-right'><i class='fa fa-chevron-right'></i></a>",
        slidesToShow: 5,
        slidesToScroll: 5,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            autoplay: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            autoplay: false
          }
        },
        {
          breakpoint: 430,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: false,
            autoplay: false
          }
        }]
        // Any other options that can be got from plugin documentation
      },
      SlickStream1: true,
      SlickStream2: false,
      Alertlogin: '',
      AlertForget: '',
      inputEmail: '',
      inputPassword: '',
      inputRemember: null,
      type: 'password',
      btnShowpass: true,
      ThumbLogin: null,
      modalLogin: false,
      auth: null,
      BannerTop: [],
      Link: null,
      modalShare: false,
      live0: [],
      lives: [],
      liveSlice: [],
      events: [],
      publicch: [],
      radioCh: [{ id: 1, thumb: require('@/assets/img/Rtaf_radio_1.png'), name: "Radio Channel 1", desc: "", live: false, src: `http://radio12.plathong.net/7172/;stream.mp3/;stream.mp3` }, { id: 2, thumb: require('@/assets/img/Rtaf_radio_2.png'), name: "Radio Channel 2", desc: " ", live: false, src: `http://radio12.plathong.net/7172/;stream.mp3/;stream.mp3` }],
      educationch: [],
      recommended0: [],
      recommended: [],
      recommendedSlice: [],
      updates: [],
      newsfeed: [],
      Category: [],
      checkUser: null,
      rtaf: [],
      showBarRadio: false,
      audioPlayer: null,
    };
  },
  mounted() {
    this.RecommendedFeed();
    this.PublicChannel();
    this.EducationChannel();
    this.ChannalLiveList();
    this.ChannalLiveEventList();
    this.ChannalRTAF();
    this.VideoLastUpdate();
    this.Newsfeed();
    this.BannerFeed();
    this.BannerLogin();
    this.Session();
    //this.ToggleLogin();
    this.feedMarquee();
    this.feedCategory();
    //console.log('this is current swiper instance object', this.swiper);
    this.swiper.slideTo(3, 1000, false);
    this.checkUser = localStorage.auth;
    this.auth = localStorage.auth;
    localStorage.pincode = '';
    this.Thumbor = Thumbor;
    this.ThumborUse = ThumborUse;

    if (localStorage.remember) {
      this.inputRemember = localStorage.remember;
      this.inputEmail = localStorage.loginemail;
      this.inputPassword = localStorage.loginpassword;
    }

  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  methods: {
    closeModalInformation() {
      this.modalInformation = !this.modalInformation;
      if (localStorage.auth == 'false' || !localStorage.auth) {
        var self = this;
        setTimeout(function () {
          self.modalLogin = true;
        }, 500);
      }
    },
    PlayVideoCategory(id) {
      document.location.assign('/#/vod/' + id);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    feedMarquee() {
      let APIgetfeedMarquee = Host + '/api/v1/marquee';
      axios.get(APIgetfeedMarquee).then(response => {
        for (var i = 0; i < response.data.result.length; i++) {
          this.linkMarquee += response.data.result[i].link;
          //array[i]
          this.marquee += response.data.result[i].message + '\xa0\xa0\xa0\xa0\xa0';
        }
      });
    },
    feedCategory() {
      let APIgetfeedCategory = Host + '/api/v1/category/video/all';
      axios.post(APIgetfeedCategory, {
        email: localStorage.emailfront
      }).then(response => {
        this.Thumb = Thumb;
        this.Category = response.data.result;

      });
    },
    ToggleLogin() {
      if (localStorage.auth == 'false' || !localStorage.auth) {
        this.$router.push('/');
        this.modalInformation = true;
      }
    },
    Session() {
      let APIgetSession = Host + '/api/v1/member/session';
      axios.post(APIgetSession, {
        token: localStorage.token
      }).then(response => {
        if (response.data.code !== '200') {
          localStorage.emailfront = '';
          localStorage.token = '';
          localStorage.auth = 'false';
        }
      });
    },
    PlayPublicChannel(data) {
      document.location.assign('/#/public/' + data.id);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    RecommendedFeed() {
      let APIgetRecommendedFeed = Host + '/api/v1/video/recommended';
      axios.post(APIgetRecommendedFeed).then(response => {
        this.recommended = response.data.result;
        this.recommended0 = response.data.result[0];
        this.recommendedSlice = response.data.result.slice(1, response.data.result.length);
      });
    },
    PublicChannel() {
      let APIgetPublicChannel = Host + '/api/v1/channel/public';
      axios.get(APIgetPublicChannel).then(response => {
        this.publicch = response.data.result;
      });
    },
    EducationChannel() {
      let APIgetEducationChannel = Host + '/api/v1/channel/education';
      axios.get(APIgetEducationChannel).then(response => {
        this.educationch = response.data.result;
      });
    },
    Viewmore(id) {
      if (localStorage.auth == 'true') {
        document.location.assign('/#/viewmore/' + id);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      } else {
        this.$router.push('/');
        this.modalLogin = true;
      }
    },
    ViewmoreCategory(id) {
      if (localStorage.auth == 'true') {
        document.location.assign('/#/category/' + id);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      } else {
        this.$router.push('/');
        this.modalLogin = true;
      }
    },
    RememberMe() {
      if (this.inputRemember) {
        localStorage.removeItem('remember');
        localStorage.removeItem('loginemail');
        localStorage.removeItem('loginpassword');
      } else {
        localStorage.setItem('remember', true);
        localStorage.setItem('loginemail', this.inputEmail);
        localStorage.setItem('loginpassword', this.inputPassword);
      }
    },
    Login() {
      let APIgetLogin = Host + '/api/v1/member/login';
      axios.post(APIgetLogin, {
        email: this.inputEmail,
        password: this.inputPassword
      }).then(response => {
        if (response.data.code == '200') {
          localStorage.typefront = response.data.type;
          localStorage.auth = 'true';
          localStorage.emailfront = this.inputEmail;
          localStorage.token = response.data.token;
          location.reload();
        } else {
          var self = this;
          this.Alertlogin = 'ชื่อผู้ใช้งานหรือรหัสผ่านไม่ถูกต้อง';
          setTimeout(function () {
            self.Alertlogin = '';
          }, 2000);
        }
      });
    },
    ShowPassword() {
      if (this.type === 'password') {
        this.type = 'text';
        this.btnShowpass = !this.btnShowpass;
      } else {
        this.type = 'password';
        this.btnShowpass = !this.btnShowpass;
      }
    },
    ClickForgetPass() {
      var self = this;
      this.AlertForget = 'กรุณาติดต่อผู้ดูแลระบบ';
      setTimeout(function () {
        self.AlertForget = '';
      }, 3000);
    },
    BannerLogin() {
      let APIgetBannerLogin = Host + '/api/v1/banner';
      axios.post(APIgetBannerLogin, {
        position: 'login'
      }).then(response => {
        this.ThumbLogin = response.data.result;
      });
    },
    ShareLink(data) {
      this.Link = data.share;
    },
    BannerFeed() {
      let APIgetBannerFeed = Host + '/api/v1/banner';
      axios.post(APIgetBannerFeed, {
        position: 'top'
      }).then(response => {
        this.BannerTop = response.data.result;
      });
    },
    AddWatchLater(data) {
      let APIgetAddWatchLater = Host + '/api/v1/watchlater/add';
      axios.post(APIgetAddWatchLater, {
        email: localStorage.emailfront,
        videoid: data.id
      }).then(response => {
        console.log(data.id);
      });
    },
    FavoriteActive(fav) {
      if (fav === "true") {
        return true;
      }
      return false;
    },
    FunctionFavorite(data) {
      if (data.favorite == 'true') {
        this.DelFavorite(data);
      } else {
        this.AddFavorite(data);
      }
    },
    DelFavorite(data) {
      let APIgetDelFavorite = Host + '/api/v1/favorite/delete';
      axios.post(APIgetDelFavorite, {
        email: localStorage.emailfront,
        videoid: data.id
      }).then(response => {
        this.VideoLastUpdate();
      });
    },
    AddFavorite(data) {
      let APIgetAddFavorite = Host + '/api/v1/favorite/add';
      axios.post(APIgetAddFavorite, {
        email: localStorage.emailfront,
        videoid: data.id
      }).then(response => {
        this.VideoLastUpdate();
      });
    },
    Newsfeed() {
      let APIgetNewsfeed = Host + '/api/v1/news';
      axios.get(APIgetNewsfeed).then(response => {
        this.newsfeed = response.data.result;
      });
    },
    PlayLiveEvent(data) {
      if (localStorage.auth == 'true') {
        document.location.assign('/#/live/' + data.id);
        location.reload();
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      } else {
        this.$router.push('/');
        this.modalLogin = true;
      }
    },
    PlayLiveStreaming(data) {
      if (localStorage.auth == 'true') {
        document.location.assign('/#/live/' + data.id);
        location.reload();
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      } else {
        this.$router.push('/');
        this.modalLogin = true;
      }
    },
    PlayLastUpdate(data) {
      if (localStorage.auth == 'true') {
        document.location.assign('/#/vod/' + data.id);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      } else {
        this.$router.push('/');
        this.modalLogin = true;
      }
    },
    ReadNews(url) {
      window.open(url);
    },
    next() {
      this.$refs.slick.next();
    },
    prev() {
      this.$refs.slick.prev();
    },
    reInit() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    },
    ChannalLiveEventList() {
      let APIgetChannalLiveEventList = Host + '/api/v1/channel/event';
      axios.get(APIgetChannalLiveEventList).then(response => {
        this.events = response.data.result;
      });
    },
    ChannalRTAF() {
      let APIgetChannalRTAF = Host + '/api/v1/channel';
      axios.get(APIgetChannalRTAF).then(response => {
        this.rtaf = response.data.result;
      });
    },
    ChannalLiveList() {
      let APIgetChannalList = Host + '/api/v1/channel/wing';
      axios.get(APIgetChannalList).then(response => {
        this.lives = response.data.result;
        this.live0 = response.data.result[0];
        this.liveSlice = response.data.result.slice(1, response.data.result.length);
      });
    },
    VideoLastUpdate() {
      let APIgetVideoLastUpdate = Host + '/api/v1/video';
      axios.post(APIgetVideoLastUpdate, {
        email: localStorage.emailfront
      }).then(response => {
        this.updates = response.data.result;
      });
    },
    CopyLink() {
      let coding = document.querySelector('#linkURL');
      coding.setAttribute('type', 'text');
      coding.select();

      try {
        var successful = document.execCommand('copy');
        if (successful == true) {
          this.success();
        }
      }
      catch (err) {
        console.log('error, please copy by Ctrl+C.');
      }
    },
    success() {
      this.$alert.success({ message: 'คัดลอกลิ้งค์แล้ว', position: 'bottom left', timeOut: 3000 });
    },
    PlayRadioChannel(radio) {
      this.changeSource(radio);
      this.toggleBarRadio(true);
    },
    toggleBarRadio(bool) {
      var floatingBar = document.getElementById("floating-bar");
      if (bool) {
        floatingBar.style.display = "initial";
      } else {
        floatingBar.style.display = "none";
        document.getElementById('myAudio').pause();
      }
    },
    changeSource(radio) {
      var audioElement = document.getElementById('myAudio');
      var sourceElement = document.getElementById('audio-src');
      var newSource = radio.src;
      sourceElement.src = newSource;
      audioElement.load();
      audioElement.play();
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

.home-feature-box {
  padding: 40px 0;
}

.home-feature-box i {
  font-size: 6rem;
}

.home-feature-box span {
  display: block;
  color: black;
  font-size: 20px;
  font-weight: bold;
  padding-top: 20px;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
}

a {
  color: #42b983;
}

.floating-bar {
  position: fixed;
  bottom: 0;
  right: 0;
  background-color: #333;
  color: white;
  padding: 10px;
  border-top-left-radius: 5px;
  /* cursor: pointer; */
  width: 100%;
  height: 60px;
  z-index: 999;
  background-image: url("/static/img/navtop1920x200.5dd1733.jpg");
  display: none;
}

.btn-close-radio {
  float: right;
  background-color: transparent;
  border: none;
}
</style>
